import React from "react";
import { useIntl } from "react-intl";
import DensoLogo from "../../components/DensoLogo/DensoLogo";
import HeadingContainer from "../../containers/HeadingContainer";
import LoginForm from "../../containers/LoginForm/LoginForm";
import AuthViewLayout from "../../layouts/AuthViewLayout";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

function LoginFormView(props) {
  const intl = useIntl();

  return (
    <AuthViewLayout
      topSection={<DensoLogo />}
      middleSection={
        <HeadingContainer
          level={2}
          heading={getLocalizedMessage(intl, "login.welcomeBack")}
          description={getLocalizedMessage(intl, "login.logIntoYourAccount")}
        />
      }
      bottomSection={<LoginForm />}
    />
  );
}

export default LoginFormView;
